import { render } from "./AppStatusBar.vue?vue&type=template&id=19db959a&scoped=true"
import script from "./AppStatusBar.vue?vue&type=script&lang=js"
export * from "./AppStatusBar.vue?vue&type=script&lang=js"

import "./AppStatusBar.vue?vue&type=style&index=0&id=19db959a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19db959a"]])

export default __exports__